<template>
  <v-layout row wrap>
    <!-- Left Column: Dịch vụ & Biểu phí list -->
    <v-flex xs12 lg7 class="pr-lg-4">
      <!-- Services row -->
      <div class="d-flex align-center flex-wrap py-4 px-4 mb-4 rounded-lg bg-light-gradient border-slate-200">
        <v-checkbox
          class="mr-4 my-0 py-0"
          dense
          hide-details
          label="Đóng gỗ"
          v-model="orderEditable.IsFragileGoods"
          :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole)"
        ></v-checkbox>
        <v-checkbox
          class="mr-4 my-0 py-0"
          dense
          hide-details
          label="Kiểm hàng A"
          v-model="isCheckPackageA"
          :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole)"
        ></v-checkbox>
        <v-checkbox
          class="mr-4 my-0 py-0"
          dense
          hide-details
          label="Kiểm hàng B"
          v-model="isCheckPackageB"
          :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole)"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-select
          class="my-0 py-0"
          style="max-width: 180px;"
          dense
          hide-details
          label="Bảo hiểm hàng"
          v-model="orderEditable.GuaranteeType"
          :items="guarantees"
          item-text="PackageName"
          item-value="ID"
          :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole)"
        ></v-select>
      </div>

      <div class="fee-list-card">
        <!-- Tỷ giá đơn -->
        <div class="fee-row">
          <div>
            <div class="fee-label">Tỷ giá đơn</div>
            <div class="fee-subtitle">Tỷ giá quy đổi CNY sang VND</div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 120px;"
              dense
              hide-details
              v-model="orderEditable.ExchangeRate"
              :decimal="0"
              :disabled="saleRole || csRole || orderReadonly || !(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole || paymentRole)"
            ></h-currency-input>
          </div>
        </div>

        <!-- Tỷ giá mua vào -->
        <div class="fee-row" v-if="adminRole">
          <div>
            <div class="fee-label">Tỷ giá mua vào</div>
            <div class="fee-subtitle">Tỷ giá thực tế mua vào tệ</div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 120px;"
              dense
              hide-details
              v-model="orderEditable.ExchangeRateBuy"
              :decimal="0"
              :disabled="!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia || adminRole)"
            ></h-currency-input>
          </div>
        </div>

        <!-- Tiền hàng trên web -->
        <div class="fee-row">
          <div>
            <div class="fee-label">Tiền hàng trên web</div>
            <div class="fee-subtitle">Tổng giá trị sản phẩm <span class="blue--text font-weight-bold">({{ order.AmountCNY | currency('CNY', 2) }})</span></div>
          </div>
          <div class="fee-value-input">
            <span class="font-weight-bold">
              {{ order.AmountVND | currency }}
            </span>
          </div>
        </div>

        <!-- Tiền mua thật -->
        <div class="fee-row" v-if="canViewRealPurchaseAmount">
          <div>
            <div class="fee-label">Tiền mua thật</div>
            <div class="fee-subtitle">Thực chi thanh toán với NCC <span class="blue--text font-weight-bold">({{order.TotalRealAmountCNY | currency('CNY', 2)}})</span></div>
          </div>
          <div class="fee-value-input">
            <span class="font-weight-bold text-slate-800">
              {{ totalRealAmount | currency }}
            </span>
          </div>
        </div>

        <!-- Phí ship TQ -->
        <div class="fee-row">
          <div>
            <div class="fee-label">Phí ship TQ</div>
            <div class="fee-subtitle">Phí vận chuyển nội địa TQ <span class="blue--text font-weight-bold">(¥{{ order.FeeShipCN | currency('', 2) }})</span></div>
          </div>
          <div class="fee-value-input">
            <span class="font-weight-bold text-slate-800">
              {{ order.FeeShipCNVND | currency }}
            </span>
          </div>
        </div>

        <!-- Tiền hoa hồng -->
        <div class="fee-row bg-emerald-50" v-if="!saleRole && !csRole">
          <div>
            <div class="fee-label">Tiền hoa hồng</div>
            <div class="fee-subtitle">Tiền hoa hồng đàm phán <span class="blue--text font-weight-bold">(¥{{ (order.CommissionFeeVND > 0 ? order.AmountCNY + order.FeeShipCN - order.TotalRealAmountCNY : 0) | currency('', 2)}})</span></div>
          </div>
          <div class="fee-value-input">
            <span class="font-weight-bold text-slate-800">
              {{ order.CommissionFeeVND | currency }}
            </span>
          </div>
        </div>

        <!-- Phí mua hàng -->
        <div class="fee-row">
          <div>
            <div class="fee-label">Phí mua hàng</div>
            <div class="fee-subtitle">Phí dịch vụ mua hộ (Chiết khấu: {{ order.FeeBuyDiscount | currency }}%)</div>
            <div class="d-flex align-center mt-1" v-if="!(order.Status != statusEnum.cho_dat_coc && order.Status != statusEnum.cho_bao_gia && !(adminRole && order.Status != statusEnum.hoan_thanh))">
              <span class="caption text-slate-500 mr-2">Tỷ lệ (%):</span>
              <h-currency-input class="compact-input" style="max-width: 60px;" dense hide-details v-model="orderEditable.FeeBuy" :decimal="1" :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"></h-currency-input>
            </div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 150px;"
              dense
              hide-details
              v-model="orderEditable.FeeBuyAmount"
              :decimal="0"
              :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"
            ></h-currency-input>
          </div>
        </div>

        <!-- Phí UTNK -->
        <div class="fee-row" v-if="canViewPurchaseRestrictedFees && orderEditable.OrderType !== 'NKTN'">
          <div>
            <div class="fee-label">Phí UTNK</div>
            <div class="fee-subtitle">Phí ủy thác nhập khẩu chính ngạch</div>
            <div class="mt-1" v-if="adminRole || paymentRole">
              <v-checkbox class="mt-0 pt-0" dense hide-details v-model="orderEditable.FeeUTNKFix" :true-value="1" :false-value="0" label="Fix phí UTNK"></v-checkbox>
            </div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 150px;"
              dense
              hide-details
              v-model="orderEditable.FeeUTNK"
              :decimal="0"
              :disabled="orderReadonly || !orderEditable.FeeUTNKFix || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"
            ></h-currency-input>
          </div>
        </div>

        <!-- Phí vận chuyển -->
        <div class="fee-row" v-if="canViewPurchaseRestrictedFees">
          <div>
            <div class="fee-label">Phí vận chuyển</div>
            <div class="fee-subtitle">Cước vận chuyển Quốc tế TQ - VN (Chiết khấu: {{ orderEditable.FeeWeightDiscount | currency }}%)</div>
            <div class="d-flex align-center mt-1 flex-wrap">
              <span class="caption text-slate-500 mr-2">Đơn giá:</span>
              <h-currency-input class="compact-input mr-3" style="max-width: 90px;" dense hide-details v-model="orderEditable.FeeWeight" :decimal="0" :disabled="orderReadonly || !(adminRole || paymentRole)"></h-currency-input>
              <template v-if="adminRole || paymentRole">
                <span class="caption text-slate-500 mr-2">Giá gốc:</span>
                <h-currency-input class="compact-input mr-3" style="max-width: 90px;" dense hide-details v-model="orderEditable.CostWeight" :decimal="0" :disabled="orderReadonly || !(adminRole || paymentRole)"></h-currency-input>
              </template>
              <span class="caption text-slate-500 mr-2">{{ order.FeeShipType == 1 ? 'CBM' : 'Cân nặng' }}:</span>
              <span class="caption font-weight-bold text-slate-700 mr-1">{{ order.OrderWeight | currency('', 2) }}</span>
              <span class="caption text-slate-500">{{ order.FeeShipType == 0 ? 'kg' : order.FeeShipType == 1 ? 'm3' : 'kg(quy đổi)' }}</span>
            </div>
            <div class="mt-1" v-if="adminRole || paymentRole">
              <v-checkbox class="mt-0 pt-0" dense hide-details v-model="orderEditable.IsUpdateFeeShip" label="Fix đơn giá vận chuyển"></v-checkbox>
            </div>
          </div>
          <div class="fee-value-input">
            <span class="font-weight-bold text-slate-800">{{ order.FeeWeightAmount | currency }}</span>
          </div>
        </div>

        <!-- Phí đóng gỗ -->
        <div class="fee-row" v-if="orderEditable.IsFragileGoods">
          <div>
            <div class="fee-label">Phí đóng gỗ</div>
            <div class="fee-subtitle">Phí dịch vụ gia cố, đóng hòm gỗ bảo vệ hàng</div>
          </div>
          <div class="fee-value-input">
            <span class="font-weight-bold text-slate-800">
              ¥{{ orderEditable.FragileFee | currency }} <span class="text-slate-400">/</span> {{ orderEditable.FragileFeeVND | currency }}
            </span>
          </div>
        </div>

        <!-- Phí kiểm hàng -->
        <div class="fee-row" v-if="orderEditable.IsCheck">
          <div>
            <div class="fee-label">Phí kiểm hàng</div>
            <div class="fee-subtitle">Phí dịch vụ kiểm đếm, đối chiếu hàng hóa</div>
          </div>
          <div class="fee-value-input">
            <span class="font-weight-bold text-slate-800">{{ orderEditable.CheckFeeVND | currency }}</span>
          </div>
        </div>

        <!-- Phí bảo hiểm -->
        <div class="fee-row" v-if="orderEditable.GuaranteeType > 0">
          <div>
            <div class="fee-label">Phí bảo hiểm</div>
            <div class="fee-subtitle">Phí bảo hiểm bảo hộ hàng hóa tránh mất mát</div>
          </div>
          <div class="fee-value-input">
            <span class="font-weight-bold text-slate-800">
              ¥{{ order.GuaranteeAmount | currency }} <span class="text-slate-400">/</span> {{ order.GuaranteeAmountVND | currency }}
            </span>
          </div>
        </div>

        <!-- Phụ phí 1 -->
        <div class="fee-row" v-if="canViewPurchaseRestrictedFees && orderEditable.OrderType !== 'NKTN'">
          <div>
            <div class="fee-label">Phụ phí 1</div>
            <div class="d-flex align-center mt-1 flex-wrap">
              <span class="caption text-slate-500 mr-2">Ghi chú:</span>
              <v-text-field class="compact-input" style="max-width: 180px;" dense hide-details v-model="orderEditable.Surcharge1Note" outlined :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"></v-text-field>
            </div>
          </div>
          <div class="fee-value-input d-flex align-center">
            <div v-if="adminRole || paymentRole" class="d-flex align-center mb-2">
              <span class="caption text-slate-500 mr-2">Gốc:</span>
              <h-currency-input
                class="flat-numeric-input"
                style="width: 150px;"
                dense
                hide-details
                v-model="orderEditable.Surcharge1CostAmount"
                :decimal="0"
                :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"
              ></h-currency-input>
            </div>
            <div class="d-flex align-center">
              <span class="caption text-slate-500 mr-2">Thu khách:</span>
              <h-currency-input
                class="flat-numeric-input"
                style="width: 150px;"
                dense
                hide-details
                v-model="orderEditable.Surcharge1Amount"
                :decimal="0"
                :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"
              ></h-currency-input>
            </div>
          </div>
        </div>

        <!-- Phụ phí 2 -->
        <div class="fee-row" v-if="canViewPurchaseRestrictedFees && orderEditable.OrderType !== 'NKTN'">
          <div>
            <div class="fee-label">Phụ phí 2</div>
            <div class="d-flex align-center mt-1 flex-wrap">
              <span class="caption text-slate-500 mr-2">Ghi chú:</span>
              <v-text-field class="compact-input" style="max-width: 180px;" dense hide-details v-model="orderEditable.Surcharge2Note" outlined :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"></v-text-field>
            </div>
          </div>
          <div class="fee-value-input d-flex align-center">
            <div v-if="adminRole || paymentRole" class="d-flex align-center mb-2">
              <span class="caption text-slate-500 mr-2">Gốc:</span>
              <h-currency-input
                class="flat-numeric-input"
                style="width: 150px;"
                dense
                hide-details
                v-model="orderEditable.Surcharge2CostAmount"
                :decimal="0"
                :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"
              ></h-currency-input>
            </div>
            <div class="d-flex align-center">
              <span class="caption text-slate-500 mr-2">Thu khách:</span>
              <h-currency-input
                class="flat-numeric-input"
                style="width: 150px;"
                dense
                hide-details
                v-model="orderEditable.Surcharge2Amount"
                :decimal="0"
                :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"
              ></h-currency-input>
            </div>
          </div>
        </div>

        <!-- Tổng hóa đơn -->
        <div class="fee-row bg-emerald-50" v-if="orderEditable.OrderType !== 'NKTN'">
          <div>
            <div class="fee-label font-weight-bold text-success">Tổng hóa đơn</div>
            <div class="fee-subtitle text-emerald-600">Tổng hóa đơn tài chính VAT</div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 150px;"
              dense
              hide-details
              v-model="order.TotalInvoicePrice"
              :decimal="0"
              disabled
            ></h-currency-input>
          </div>
        </div>

        <!-- Thuế khác -->
        <div class="fee-row" v-if="orderEditable.OrderType !== 'NKTN'">
          <div>
            <div class="fee-label">Thuế khác</div>
            <div class="d-flex align-center mt-1 flex-wrap">
              <span class="caption text-slate-500 mr-2">Tỷ lệ:</span>
              <h-currency-input class="compact-input mr-3" style="max-width: 60px;" dense hide-details v-model="orderEditable.TaxOtherRate" :decimal="2" label="%" :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"></h-currency-input>
              <span class="caption text-slate-500 mr-2">Ghi chú:</span>
              <v-text-field class="compact-input" style="max-width: 180px;" dense hide-details v-model="orderEditable.TaxOtherNote" outlined :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"></v-text-field>
            </div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 150px;"
              dense
              hide-details
              v-model="orderEditable.TaxOtherAmount"
              :decimal="0"
              :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"
            ></h-currency-input>
          </div>
        </div>

        <!-- Thuế NK -->
        <div class="fee-row" v-if="orderEditable.OrderType !== 'NKTN'">
          <div>
            <div class="fee-label">Thuế NK</div>
            <div class="d-flex align-center mt-1 flex-wrap">
              <span class="caption text-slate-500 mr-2">Ghi chú:</span>
              <v-text-field class="compact-input" style="max-width: 180px;" dense hide-details v-model="orderEditable.TaxNKNote" outlined :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"></v-text-field>
            </div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 150px;"
              dense
              hide-details
              v-model="orderEditable.TaxNKAmount"
              :decimal="0"
              :disabled="orderReadonly || !(order.Status != statusEnum.hoan_thanh && (adminRole || paymentRole))"
            ></h-currency-input>
          </div>
        </div>

        <!-- Thuế VAT -->
        <div class="fee-row" v-if="orderEditable.OrderType !== 'NKTN'">
          <div>
            <div class="fee-label">Thuế VAT</div>
            <div class="d-flex align-center mt-1 flex-wrap">
              <span class="caption text-slate-500 mr-2">Ghi chú:</span>
              <v-text-field class="compact-input" style="max-width: 180px;" dense hide-details v-model="orderEditable.TaxVATNote" outlined :disabled="orderReadonly || (!(order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia) && !((adminRole || paymentRole) && order.Status != statusEnum.hoan_thanh))"></v-text-field>
            </div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 150px;"
              dense
              hide-details
              v-model="orderEditable.TaxVATAmount"
              :decimal="0"
              :disabled="orderReadonly || !(order.Status != statusEnum.hoan_thanh && (adminRole || paymentRole))"
            ></h-currency-input>
          </div>
        </div>

        <!-- Phí khác -->
        <div class="fee-row">
          <div>
            <div class="fee-label">Phí khác</div>
            <div class="d-flex align-center mt-1 flex-wrap">
              <span class="caption text-slate-500 mr-2">Ghi chú:</span>
              <v-text-field class="compact-input" style="max-width: 240px;" dense hide-details v-model="orderEditable.FeeOtherNote" outlined :disabled="!(order.Status != statusEnum.hoan_thanh && (adminRole || paymentRole || purchaseRole))"></v-text-field>
            </div>
          </div>
          <div class="fee-value-input">
            <h-currency-input
              class="flat-numeric-input"
              style="width: 150px;"
              dense
              hide-details
              v-model="orderEditable.FeeOther"
             
              :decimal="0"
              :disabled="!(order.Status != statusEnum.hoan_thanh && (adminRole || paymentRole || purchaseRole))"></h-currency-input>
          </div>
        </div>
      </div>
    </v-flex>

    <!-- Right Column: Payment Summary / Cost Summary Card -->
    <v-flex xs12 lg5 class="mt-4 mt-lg-0">
      <div class="v-widget-title subtitle-1 font-weight-bold mb-3 grey--text text--darken-3 border-bottom pb-1">TỔNG KẾT CHI PHÍ</div>

      <!-- Inputs section -->
      <v-card outlined class="pa-4 rounded-lg bg-white border-slate-200 mb-4">
        <div class="d-flex justify-space-between align-center mb-3">
          <span class="body-2 font-weight-bold text-slate-700">Chiết khấu VND</span>
          <h-currency-input
            style="max-width: 200px"
            dense
            hide-details
            v-model="orderEditable.DiscountVND"
            :decimal="0"
           
            :disabled="!(order.Status != statusEnum.da_thanh_toan && order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.huy_don_hang && adminRole)"
          ></h-currency-input>
        </div>
        <div class="d-flex justify-space-between align-center mb-3">
          <span class="body-2 font-weight-bold text-slate-700">Đề xuất cọc (Tối thiểu)</span>
          <h-currency-input
            style="max-width: 200px"
            :disabled="orderReadonly"
            dense
            hide-details
            v-model="orderEditable.MinDeposit"
            :decimal="0"
           
          ></h-currency-input>
        </div>
        <div class="d-flex justify-space-between align-center">
          <span class="body-2 font-weight-bold text-slate-700">Đã thanh toán (Cọc)</span>
          <h-currency-input
            style="max-width: 200px"
            dense
            hide-details
            v-model="orderEditable.Deposit"
            :decimal="0"
           
            :disabled="orderReadonly || !(order.Status != statusEnum.hoan_thanh && adminRole)"
          ></h-currency-input>
        </div>
      </v-card>

      <!-- Gradient Balance Card -->
      <div class="gradient-balance-card text-white rounded-lg p-5 shadow-lg relative overflow-hidden elevation-2">
        <div class="absolute-decor-icon">
          <v-icon size="120" class="white--text opacity-10">fas fa-wallet</v-icon>
        </div>

        <div class="relative-content">
          <p class="caption text-blue-100 font-weight-bold text-uppercase tracking-widest mb-1">TỔNG GIÁ TRỊ ĐƠN HÀNG</p>
          <h2 class="display-1 font-weight-black white--text mb-4 tracking-tight">{{ order.TotalAmountVND | currency }}</h2>

          <v-divider dark class="my-3 opacity-20"></v-divider>

          <div class="space-y-3">
            <div class="d-flex justify-space-between align-center text-sm py-1">
              <span class="text-blue-100 font-weight-medium">Đã cọc / Đã thanh toán:</span>
              <span class="font-weight-black text-emerald-300">{{ orderEditable.Deposit | currency }}</span>
            </div>

            <div class="d-flex justify-space-between align-center text-sm py-1">
              <span class="text-blue-100 font-weight-medium">Còn lại cần thu:</span>
              <span class="font-weight-black text-rose-300">{{ remainAmount | currency }}</span>
            </div>

            <div class="pt-3">
              <div class="d-flex justify-space-between align-center text-xs text-blue-100 mb-1.5">
                <span>Tiến độ thanh toán:</span>
                <span class="font-weight-bold">{{ order.TotalAmountVND ? Math.round((orderEditable.Deposit / order.TotalAmountVND) * 100) : 0 }}%</span>
              </div>
              <v-progress-linear
                :value="order.TotalAmountVND ? Math.min(100, Math.max(0, Math.round((orderEditable.Deposit / order.TotalAmountVND) * 100))) : 0"
                color="green accent-3"
                height="6"
                rounded
                class="elevation-1"
              ></v-progress-linear>
            </div>
          </div>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import configs from "@/configs";
export default {
  name: "TabFinance",
  props: {
    order: {
      type: Object,
      required: true
    },
    orderEditable: {
      type: Object,
      required: true
    },
    statusEnum: {
      type: Object,
      required: true
    },
    adminRole: {
      type: Boolean,
      required: true
    },
    paymentRole: {
      type: Boolean,
      required: true
    },
    purchaseRole: {
      type: Boolean,
      required: true
    },
    guarantees: {
      type: Array,
      required: true
    },
    orderReadonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCheckPackageA: false,
      isCheckPackageB: false
    };
  },
  computed: {
    canViewRealPurchaseAmount() {
      return this.adminRole || this.paymentRole || this.purchaseRole;
    },
    canViewPurchaseRestrictedFees() {
      return !this.purchaseRole || this.adminRole;
    },
    totalRealAmount() {
      const rate = this.order.ExchangeRate;
      return (this.orderEditable.TotalRealAmountCNY || 0) * rate;
    },
    remainAmount() {
      return (this.order.TotalAmountVND || 0) - (this.orderEditable.Deposit || 0);
    },
    saleRole() {
      if (this.adminRole) return false;
      const user = this.$store.state.authentication.user || {};
      const roleType = Number(user.roletype || user.RoleType || 0);
      return (roleType & configs.ROLE_TYPE.Sale) === configs.ROLE_TYPE.Sale || Number(user.IsSaleLeader || 0) === 1;
    },
    csRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) === configs.ROLE_TYPE.CustomerService;
    }
  },
  watch: {
    order: {
      handler(newOrder) {
        if (newOrder) {
          this.isCheckPackageA = !!(newOrder.IsCheck && newOrder.CheckFeeType == 1);
          this.isCheckPackageB = !!(newOrder.IsCheck && newOrder.CheckFeeType == 2);
        }
      },
      immediate: true,
      deep: true
    },
    isCheckPackageA(newVal) {
      if (newVal) {
        this.isCheckPackageB = false;
        this.orderEditable.IsCheck = 1;
        this.orderEditable.CheckFeeType = 1;
      }
      if (!newVal && !this.isCheckPackageB) {
        this.orderEditable.IsCheck = 0;
        this.orderEditable.CheckFeeType = 0;
      }
    },
    isCheckPackageB(newVal) {
      if (newVal) {
        this.isCheckPackageA = false;
        this.orderEditable.IsCheck = 1;
        this.orderEditable.CheckFeeType = 2;
      }
      if (!newVal && !this.isCheckPackageA) {
        this.orderEditable.IsCheck = 0;
        this.orderEditable.CheckFeeType = 0;
      }
    }
  }
};
</script>

<style scoped>
.bg-light-gradient {
  background: linear-gradient(to bottom, #fcfcfc, #f8fafc) !important;
  border: 1px solid #e2e8f0 !important;
}
.border-bottom {
  border-bottom: 2px solid #1976d2;
}
.border-slate-200 {
  border: 1px solid #e2e8f0 !important;
}
.gradient-balance-card {
  background: linear-gradient(135deg, #1976d2 0%, #6f00f0 100%) !important;
  position: relative;
  overflow: hidden;
  color: #ffffff;
}
.absolute-decor-icon {
  position: absolute;
  right: -10px;
  bottom: -20px;
  pointer-events: none;
}
.opacity-10 {
  opacity: 0.1 !important;
}
.opacity-20 {
  opacity: 0.2 !important;
}
.relative-content {
  position: relative;
  padding: 12px 24px;
  z-index: 2;
}
.text-blue-100 {
  color: #dbeafe !important;
}
.text-emerald-300 {
  color: #6ee7b7 !important;
}
.text-rose-300 {
  color: #fca5a5 !important;
}
.space-y-3 > * + * {
  margin-top: 12px !important;
}
.fee-list-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #ffffff;
  overflow: hidden;
  margin-bottom: 24px;
}
.fee-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.fee-row:last-child {
  border-bottom: none;
}
.fee-label {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}
.fee-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}
.fee-value-input {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.compact-input >>> input {
  font-size: 13px;
  padding: 2px 4px !important;
  height: 24px !important;
}
.compact-input >>> .v-input__slot {
  min-height: 24px !important;
}
.compact-input >>> .v-input__slot:before,
.compact-input >>> .v-input__slot:after {
  display: none !important;
}
.compact-input:not(.v-input--is-disabled):hover >>> input {
  border-bottom: 1px dashed #1976d2 !important;
}
.bg-emerald-50 {
  background-color: #ecfdf5 !important;
}
.text-emerald-600 {
  color: #059669 !important;
}
</style>
